import React, { memo } from 'react';
import { Box, Container, Heading, Text, Stack } from '@chakra-ui/react';
export const Header = memo(function Header() {
  return <Box as="header" bgGradient="linear(to-r, #2c0842, #1E73BE)" color="white" py={12} width="100%" style={{
    contentVisibility: 'auto',
    containIntrinsicSize: '0 400px'
  }} data-id="element-72">
      <Container maxW="container.xl" data-id="element-73">
        <Stack spacing={4} textAlign="center" data-id="element-74">
          <Heading as="h1" size="2xl" fontWeight="bold" style={{
          fontDisplay: 'swap'
        }} data-id="element-75">
            Martin's AI Kit
          </Heading>
          <Text fontSize="xl" maxW="800px" mx="auto" style={{
          fontDisplay: 'swap'
        }} data-id="element-76">
            The 9 AI tools I actually use every day. No fluff, just what works
            for me.
          </Text>
        </Stack>
      </Container>
    </Box>;
});